import { useState } from "react";
import { useIsomorphicLayoutEffect } from "./useIsomorphicLayoutEffect";
export function useIsServer() {
    const [isServer, setIsServer] = useState(true);
    useIsomorphicLayoutEffect(() => {
        setIsServer(false);
    }, []);
    return isServer;
}
